import { registerSectionComponent } from '../../../config/sectionRegistry';
import AboutHeroSection from './AboutHeroSection';
import AboutMissionSection from './AboutMissionSection';
import AboutValuesSection from './AboutValuesSection';
import AboutTeamSection from './AboutTeamSection';
import AboutPartnersSection from './AboutPartnersSection';
import AboutContactCardSection from './AboutContactCardSection';

// Register each About page section with its metadata
registerSectionComponent('about_hero', AboutHeroSection, {
  category: 'hero',
  label: 'About Hero',
  description: 'About page hero banner with title and background',
  supportedPages: ['about'],
});

registerSectionComponent('about_mission', AboutMissionSection, {
  category: 'content',
  label: 'Mission Statement',
  description: 'Organization mission and purpose',
  supportedPages: ['about'],
});

registerSectionComponent('about_values', AboutValuesSection, {
  category: 'content',
  label: 'Core Values',
  description: 'Organization values and principles',
  supportedPages: ['about'],
});

registerSectionComponent('about_team', AboutTeamSection, {
  category: 'content',
  label: 'Team/Full Page Content',
  description: 'Team photos/bios or full page content from CMS',
  supportedPages: ['about'],
});

registerSectionComponent('about_partners', AboutPartnersSection, {
  category: 'promo',
  label: 'Partners Carousel',
  description: 'Partner logos image carousel',
  supportedPages: ['about'],
});

registerSectionComponent('about_contact_card', AboutContactCardSection, {
  category: 'content',
  label: 'Contact Card',
  description: 'Contact information CTA block',
  supportedPages: ['about'],
});

// Export components for direct use if needed
export {
  AboutHeroSection,
  AboutMissionSection,
  AboutValuesSection,
  AboutTeamSection,
  AboutPartnersSection,
  AboutContactCardSection,
};
